import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as ConversionIcon } from 'assets/icons/conversion-icon.svg';
import { ReactComponent as StreakIcon } from 'assets/icons/streak-control.svg';
import { ReactComponent as CashBackIcon } from 'assets/icons/cashback.svg';
import { ReactComponent as PauseIcon } from 'assets/icons/pause-control.svg';

import { ROUTE_KEYS } from 'utils/constants';
import PageHeaderText from 'components/base/page-header-text';
import useDashboardContext from 'contexts/dashboard.context';
import AccessDenied from 'components/access-denied';

const Maintenance = () => {
  const { permissions } = useDashboardContext();
  const MaintenanceList = [
    {
      icon: <ConversionIcon className='text-[#F73B58]' />,
      title: 'Conversion rate',
      description: 'Manage Conversion rates from FC points to Naira',
      route: ROUTE_KEYS.CONVERSION_RATE
    },
    {
      icon: <PauseIcon />,
      title: 'Pause Control',
      description: 'Manage streak operations and payouts',
      route: ROUTE_KEYS.PAUSE_CONTROL
    },
    {
      icon: <StreakIcon />,
      title: 'Streak Control',
      description: 'Manage streak operations and payouts',
      route: ROUTE_KEYS.STREAK_CONTROL
    },
    {
      icon: <CashBackIcon />,
      title: 'Cashback Control',
      description: 'Manage streak operations and payouts',
      route: ROUTE_KEYS.CASHBACK_CONTROL
    }
  ];

  const canAccessRewards = permissions.canAccessRewards;
  if (!canAccessRewards) return <AccessDenied />;
  return (
    <div>
      <PageHeaderText title='Maintenance' />
      <div className='flex gap-[24px] w-full flex-wrap'>
        {MaintenanceList.map(({ icon, title, description, route }, index) => (
          <Link to={route} key={index}>
            <div className='w-full min-w-[283px] h-[227px] bg-transparent rounded-md border border-[#F2F2F3] pt-[36px] px-[24px] hover:bg-gray-light cursor-pointer'>
              <div className='flex justify-between text-[#F73B58]'>{icon}</div>
              <h6 className='text-gray-6 text-xl font-semibold mt-10'>{title}</h6>
              <p className='text-gray-8 text-sm font-md mt-2'>{description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Maintenance;
